import React, { Component } from 'react';
import { goBack, replace } from 'react-router-redux';
import {
  Container,
  Menu,
  Segment,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';

export default class NavBar extends Component {
  static propTypes = {
    links: PropTypes.node,
    children: PropTypes.node,
    size: PropTypes.string,
    header: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
    noBack: PropTypes.bool,
    backURL: PropTypes.string,
    leftNav: PropTypes.node,
    rightNav: PropTypes.node,
    bottomNode: PropTypes.node,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  constructor(props) {
    super(props);
    this.state = {
      isOver: false,
    };
  }
  componentDidMount() {
    window.addEventListener('scroll', this.onScroll, false);
    window.scrollTo(0, 0);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll, false);
    window.scrollTo(0, 0);
  }
  onScroll = () => {
    const offsetY = window.pageYOffset;
    const isOver = offsetY > 200;
    if (isOver !== this.state.isOver) {
      this.setState({ isOver });
    }
  }
  handleGoBack = (e) => {
    e.preventDefault();
    const { store } = this.context;
    if (this.props.backURL && window.history.length <= 1) {
      store.dispatch(replace(this.props.backURL));
      return;
    }
    store.dispatch(goBack());
  }
  render() {
    return (
      <div className={`app-nav ${this.state.isOver ? 'fixed' : ''}`}>
        <Segment
          basic vertical
          inverted={this.state.isOver}
        >
          <Container>
            <Menu
              fluid secondary
              size={this.props.size}
              inverted={this.state.isOver}
            >
              {
                this.props.leftNav || (!this.props.noBack &&
                <Menu.Item
                  link
                  href="/"
                  icon="left chevron"
                  onClick={this.handleGoBack}
                />)
              }
              {
                this.props.header ? <Menu.Item header content={this.props.header} /> : null
              }
              {this.props.children || this.props.links}
              {
                this.props.rightNav ?
                  <Menu.Menu position="right">
                    {this.props.rightNav}
                  </Menu.Menu>
                : null
              }
            </Menu>
            {(this.props.bottomNode && this.state.isOver) && this.props.bottomNode}
          </Container>
        </Segment>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NavBar.jsx